import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { reportsService } from '../../../services/supabaseService';

const DashboardStats = ({ language }) => {
  const [stats, setStats] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const data = await reportsService?.getDashboardStats();
      setStats(data);
    } catch (error) {
      console.error('Failed to load stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {[1, 2, 3, 4]?.map((i) => (
          <div key={i} className="bg-card border border-border rounded-lg p-5 animate-pulse">
            <div className="h-12 w-12 bg-muted rounded-lg mb-3" />
            <div className="h-8 w-16 bg-muted rounded mb-1" />
            <div className="h-4 w-24 bg-muted rounded" />
          </div>
        ))}
      </div>
    );
  }

  const statsData = [
    {
      id: 1,
      label: { en: 'Total Queries', zh: '总查询数' },
      value: stats?.totalQueries || 0,
      change: '+12.5%',
      trend: 'up',
      icon: 'MessageSquare',
      color: 'primary'
    },
    {
      id: 2,
      label: { en: 'Chinese Buyers', zh: '中国买家' },
      value: stats?.chineseQueries || 0,
      change: `${Math.round((stats?.chineseQueries / stats?.totalQueries) * 100) || 0}%`,
      trend: 'up',
      icon: 'Users',
      color: 'secondary'
    },
    {
      id: 3,
      label: { en: 'Active Beans', zh: '活跃咖啡豆' },
      value: stats?.activeBeans || 0,
      change: '+8',
      trend: 'up',
      icon: 'Coffee',
      color: 'accent'
    },
    {
      id: 4,
      label: { en: 'Pending Queries', zh: '待处理查询' },
      value: stats?.pendingQueries || 0,
      change: '-5',
      trend: 'down',
      icon: 'Clock',
      color: 'warning'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      primary: 'bg-primary/10 text-primary',
      secondary: 'bg-secondary/10 text-secondary',
      accent: 'bg-accent/10 text-accent-foreground',
      warning: 'bg-warning/10 text-warning'
    };
    return colors?.[color] || colors?.primary;
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statsData?.map((stat) => (
        <div key={stat?.id} className="bg-card border border-border rounded-lg p-5 shadow-sm hover:shadow-md transition-smooth">
          <div className="flex items-start justify-between mb-3">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${getColorClasses(stat?.color)}`}>
              <Icon name={stat?.icon} size={24} />
            </div>
            <div className={`flex items-center gap-1 text-sm font-medium ${stat?.trend === 'up' ? 'text-success' : 'text-error'}`}>
              <Icon name={stat?.trend === 'up' ? 'TrendingUp' : 'TrendingDown'} size={16} />
              <span>{stat?.change}</span>
            </div>
          </div>
          <h3 className="text-2xl font-bold text-foreground mb-1">{stat?.value}</h3>
          <p className="text-sm text-muted-foreground">{stat?.label?.[language]}</p>
        </div>
      ))}
    </div>
  );
};

export default DashboardStats;